<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                  <FormSection title="Support Us">
                      <div>
                          <AmountSelector/>                    
                          <ErrorLabel field="amount" />
                          <br/>
                          <ShortNote/>                    
                      </div>
                  </FormSection>
                  <FormSection title="Donation Frequency">
                    <DonationFrequency />
                  </FormSection>
                  <FormSection title="Your Details">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>
                      <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
                      <br/>
              <div class="radio-part">
                <input
                  id="type_attending"
                  name="Attending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'yes'"
                  @click="setValue('custom.AttendInPerson', 'yes')"
                />
                <FormLabel for="type_attending">
                  I currently plan on attending in person
                </FormLabel>
              </div>
              <div class="radio-part">
                <input
                  name="Attending"
                  id="type_noattending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'no'"
                  @click="setValue('custom.AttendInPerson', 'no')"
                />
                <FormLabel for="type_noattending">
                  I currently do not plan on attending in person
                </FormLabel>
              </div>
              <ErrorLabel field="custom.AttendInPerson" />
              <div v-if="getValue('custom.AttendInPerson') == 'yes'">
                <br />
                <FormRow>
                  <div style="width: 100%">
                    <FormLabel class="control-label">
                      Names of Guests:
                    </FormLabel>
                    <FormInput type="textarea" class="width-full" field="custom.guests" />
                  </div>
                </FormRow>
              </div>


                  </FormSection>                
                  <FormSection title="Billing Information" >
                      <DonorAddress />
                  </FormSection>
                  <FormSection title="Payment Information" last>
                    <FormRow>
                        <PaymentType cc_text="Credit Card" check_text="Check" />
                      </FormRow>
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                      </FormRow>
                      <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Yachad<br />
                      c/o Rebecca Shatz<br />
                      40 Rector St, 4th Floor<br />
                      New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>                      
                  <!-- <FormRow>
                    <Receipt :receipts="['canadian', 'us']" />
                  </FormRow>                 -->
                  </FormSection>
                  <PaymentButton showAmount btnText="Donate"/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>
  
  <script lang="ts">
  import { onMounted } from 'vue'
  import { defineComponent } from 'vue'
  import { usePaymentForm } from '~/shared/use-payment-form'
  import { queryParams } from '~/shared/query-params'
  
  export default defineComponent({
    props: {
      subCampaign: String,
    },
    setup(props) {
      const { setValue, form, getValue, submit } = usePaymentForm();

  
      return {
        form,
        setValue,
      getValue,
        submit,
      }
    },
  })
  </script>
  <style scoped lang="scss">
  
  h2.payment-heading {
    display: flex;
    justify-content: space-between;
  }
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .fee-total {
    margin-bottom: 0;
    justify-content: space-between;
  }


.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}

.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}

::v-deep label {
  text-transform: none;
  font-weight: 600;
    letter-spacing: normal;
}
::v-deep span.flex > span {
    display: flex;
}
  </style>
  
  